// Neutral initials avatar — replaces generic stock-face avatars in reviews/testimonials
// for demonstrably authentic social proof.
const COLORS = ["#7C3AED", "#0EA5E9", "#059669", "#D97706", "#DC2626", "#DB2777", "#2563EB", "#0891B2"];

const hashStr = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

export const InitialsAvatar = ({ name = "", size = 40, className = "" }) => {
  const clean = (name || "").trim();
  const initials =
    clean.split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("") || "?";
  const color = COLORS[hashStr(clean || "x") % COLORS.length];
  return (
    <span
      data-testid="initials-avatar"
      aria-hidden="true"
      style={{ width: size, height: size, backgroundColor: `${color}26`, color }}
      className={`inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold ${className}`}
    >
      <span style={{ fontSize: Math.round(size * 0.4) }}>{initials}</span>
    </span>
  );
};

export default InitialsAvatar;
